module.exports = __webpack_public_path__ + "img/dashboard.6c695286.svg";